import { render, staticRenderFns } from "./ModalEliminarProyecto.vue?vue&type=template&id=b7bf2d02&"
import script from "./ModalEliminarProyecto.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports